export const NOTIFICATIONS = {
  // General notifications
  BAD_REQUEST: 'Something went wrong. Try again later.',
  NOT_FOUND: 'Not found.',
  FORBIDDEN: 'Forbidden.',
  UNAUTHORIZED: 'You are not authenticated.',
  DEPENDENCY_ERROR: 'Dependency service error.',
  SERVER_ERROR: 'Internal server error.',
  RESPONSE_ERROR: 'Something went wrong. Check network connection and try again.',
  INVALID_JWT_TOKEN: 'Invalid format of the JWT token provided',

  // User update messages
  USER_INFO_UPDATED_SUCCESSFULLY: 'User data has been updated',
  USER_INFO_UPDATE_ERROR: 'Error during updating user information',

  // Miner update messages
  MINER_INFO_UPDATED_SUCCESSFULLY: 'Miner data has been updated',
  MINER_INFO_UPDATE_ERROR: 'Error during updating miner information',

  // Validation messages
  INVALID_VALUE: 'Invalid value',
  INVALID_DATE: 'Invalid Date',
  INVALID_PHONE_NUMBER: 'Invalid Phone Number',
  REQUIRED_VALUE: 'Input should not be empty',
  MIN_AMOUNT: 'Amount should be greater than',

  // User messages
  NO_WALLETS: 'No wallets found',

  // Pools connection
  NICEHASH_CONNECTED: 'Connected to NiceHash successfully!',
  NICEHASH_CONNECTION_ERROR: 'Could not connect to NiceHash',

  VIABTC_CONNECTED: 'Connected to Via BTC successfully!',
  VIABTC_CONNECTION_ERROR: 'Could not connect to Via BTC',
  POWERPOOL_CONNECTED: 'Connected to PowerPool successfully!',
  POWERPOOL_CONNECTION_ERROR: 'Could not connect to PowerPool',

  OURPOOL_CONNECTED: 'Connected to OurPool successfully!',
  OURPOOL_CONNECTION_ERROR: 'Could not connect to OurPool',

  //Top up message
  TOP_UP_REQUEST_SUCCESS: 'Top up balance request created successfully!',
  TOP_UP_REQUEST_FAILED: 'Could not create top up request',

  //Download invoice
  DOWNLOAD_INVOICE_SUCCESS: 'Downloaded successfully!',
  DOWNLOAD_INVOICE_FAILED: 'Error during downloading invoice',

  //Purchase hardware
  GENERATE_CONTRACT_SUCCESS: 'Contract generated sucessfully!',
  GENERATE_CONTRACT_FAILED: 'Failed to generate contract',
  PURCHASE_HARDWARE_SUCCESS: 'Redirected to payment!',
  PURCHASE_HARDWARE_FAILED: 'Error during purchasing hardware',

  //Tasks
  RESOLVE_TASK_SUCCESS: 'Task marked as resolved!',
  RESOLVE_TASK_ERROR: 'Could not resolve task',

  //Billing
  THRESHOLD_SAVED: 'Alert threshold saved!',
  THRESHOLD_SAVE_ERROR: 'Could not save alert threshold',
  THRESHOLD_INVALID: 'Threshold must be a non-negative number',
  AUTO_TOPUP_SAVED: 'Auto top-up settings saved!',
  AUTO_TOPUP_ERROR: 'Could not update auto top-up settings',
  AUTO_TOPUP_INVALID: 'Enter a valid threshold and top-up amount',
};

export const TOOLTIP_MESSAGES = {
  ACTIVE_BALANCE: `The Balance is used for your daily electricity costs. 
  We deduct each 24 hours the used electricity. 
  Please make sure that the Balance is always positive to keep your miners online.`,
  BLOCKED_DEPOSIT: `The Deposit is the average electricity consumption for 1 month. 
  The Deposit is needed for the electricity supplier to secure a fixed price over the complete contract
  duration. After the contract duration the Deposit will be fully paid back.`,
  BALANCE: `Pool payouts are processed once daily. 
  The mined coins stay in the pool until they are transferred to your wallet during the next payout.`,
  EARNINGS: `The total amount mined Bitcoins.`,
  ESTIMATED_MINING_DAYS: `Estimated mining days left based on your actual Balance.`,
};
